//#region imports
import React, { useEffect, useState } from "react";

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";
import {
  selectAllTaskWithFilterStatus,
  selectAllTasksWithFilterCSV,
  resetAllTasksWithFilter,
  selectTimeLineAnalytics
} from "_redux/slices/timeline/employees";
import { getAirportBase64Logo, selectAirportBase64Logo } from "_redux/slices/analytics/reviews";

// tremor
import { Subtitle, Title } from "@tremor/react";

// bootstrap
import { Col, Row } from 'react-bootstrap';

// styles
import { Colors } from "_styles";

// csv
import { makeExcel } from "_utils/makeExcel";

// custom components
import { ExcelDownloadIcon } from '_atoms';
import TimelineAnalyticsFilter from "./timeline-analytics-filter";
import TimelineAnalyticsTable from "./timeline-analytics-table";

// custom modal
import ActionsModal from "_components/molecules/Modals/actions-modal";

//#endregion

//#region excel variables
const allTasksTitles = [
  "Index",
  "Service Status",
  "Request Type",
  "Flight Date",
  "Flight No",
  "Flight Time",
  "Origin",
  "Destination",
  "Seat No",
  "Assign Time",
  "Acknowledge Time",
  "Service Time (Starting time)",
  "Return Time (Completion tme)",
  "Service Duration",
  "PRN (Payroll Number)",
  "Worker Name",
  "Arr/Dep",
  "Remarks (Reason for rejection)",
];

const completetTasksTitles = [
  "Index",
  "Request Type",
  "Flight Date",
  "Flight No",
  "Flight Time",
  "Origin",
  "Destination",
  "Seat No",
  "Assign Time",
  "Acknowledge Time",
  "Service Time (Starting time)",
  "Return Time (Completion tme)",
  "Service Duration",
  "PRN (Payroll Number)",
  "Worker Name",
  "Arr/Dep",
];
const rejectedTasksTitles = [
  "Index",
  "Request Type",
  "Flight Date",
  "Flight No",
  "Flight Time",
  "Origin",
  "Destination",
  "Seat No",
  "Assign Time",
  "Security No",
  "PRN (Payroll Number)",
  "Worker Name",
  "Arr/Dep",
  "Passenger Name",
  "Remarks (Reason for rejection)",
];

const assignedTasksTitles = [
  "Index",
  "Request Type",
  "Flight Date",
  "Flight No",
  "Flight Time",
  "Origin",
  "Destination",
  "Seat No",
  "Assign Time",
  "PRN (Payroll Number)",
  "Worker Name",
  "Arr/Dep",
];

//#endregion

// card used to display analytics
const CustomCard = (props) => {
  return (
    <div
      style={{
        textAlign: "left", borderStyle: "solid", borderWidth: "0.5px", borderRadius: "5px", borderColor: "lightgrey", justifyContent: "space-between",
        borderTopWidth: "5px", borderTopLeftRadius: 10, borderTopRightRadius: 10, borderTopColor: Colors.PRM_LIGHT_BLUE, padding: 8,
      }}
    >
      <div style={{ minHeight: '50%' }}>
        <Subtitle>{props.title}</Subtitle>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <p style={{ textAlign: "left", color: "black", fontWeight: 'bold', fontSize: 32, marginTop: -8 }}>{props.data}</p>
        <ExcelDownloadIcon onClick={props.onClick} simple={true} clickable={true} style={{ marginTop: 8, cursor: 'pointer' }} />
      </div>
    </div>
  );
};

const TimelineAnalytics = () => {

  //#region redux
  const dispatch = useDispatch();
  const dbUser = useSelector(selectFirebaseInfo); // logged in user
  const allTaskWithFilterStatus = useSelector(selectAllTaskWithFilterStatus); // all tasks with filter status
  const allTasksWithFilterCSV = useSelector(selectAllTasksWithFilterCSV); // all tasks with filter CSV  
  const timeLineAnalytics = useSelector(selectTimeLineAnalytics);
  const base64Logo = useSelector(selectAirportBase64Logo);
  console.log(timeLineAnalytics, "timeLineAnalytics...")
  //#endregion

  //#region local states
  const [filterModal, setFilterModal] = useState(false);
  const [analyticsType, setAnalyticsType] = useState("");
  //#endregion

  //#region functions
  // calculate the total number of completed tasks
  const handleExcel = async (fileName, columnTitles, rows) => {
    let data = {};
    data.fileName = fileName;
    data.workSheetName = [fileName];
    data.columnTitles = [columnTitles];
    data.columnWidth = [columnTitles?.map((row) => row.length + 50)];
    data.rows = [rows];
    await makeExcel(data, dbUser.details.authority, base64Logo);
  };

  // close excel sheet filter modal
  const closeFilterModal = () => {
    setFilterModal(false);
    dispatch(resetAllTasksWithFilter());
  };

  // open excel sheet filter modal
  const openFilterModal = (type) => {
    setAnalyticsType(type);
    setFilterModal(true);
  };
  //#endregion

  //#region useEffects
  useEffect(() => {
    if (allTaskWithFilterStatus == "succeeded") {
      if (analyticsType == "totalTasks") handleExcel(`Total-Tasks`, allTasksTitles, allTasksWithFilterCSV);

      if (analyticsType == "totalTasksCompleted") {
        let completedCSVData = [];
        let completedCounter = 1;
        let tempCompletedTasks = allTasksWithFilterCSV?.filter(
          (row) => row?.serviceStatus == "completed"
        );
        if (tempCompletedTasks?.length > 0) {
          tempCompletedTasks.forEach((task) => {
            let completedOBJ = {
              index: `${completedCounter++}`,
              requestType: task?.requestType,
              flightDate: task?.flightDate,
              flightNo: task?.flightNo,
              flightTime: task?.flightTime,
              origin: task?.origin,
              destination: task?.destination,
              seatNo: task?.seatNo,
              assignedTime: task?.assignedTime,
              acknowledgedTime: task?.acknowledgedTime,
              startTime: task?.startTime,
              completeTime: task?.completeTime,
              serviceDuration: task?.serviceDuration,
              prn: task?.prn,
              workerName: task?.workerName,
              arrDep: "A",
            };
            completedCSVData.push(completedOBJ);
          });
        }
        handleExcel(`Completed-Tasks`, completetTasksTitles, completedCSVData);
      }
      if (analyticsType == "totalRejectedTasks") {
        let rejectedCSVData = [];
        let rejectedCounter = 1;
        let tempRejectedTasks = allTasksWithFilterCSV?.filter(
          (row) => row?.serviceStatus == "rejected"
        );
        if (tempRejectedTasks?.length > 0) {
          tempRejectedTasks.forEach((task) => {
            let rejectedOBJ = {
              index: `${rejectedCounter++}`,
              requestType: task?.requestType,
              flightDate: task?.flightDate,
              flightNo: task?.flightNo,
              flightTime: task?.flightTime,
              origin: task?.origin,
              destination: task?.destination,
              seatNo: task?.seatNo,
              assignedTime: task?.assignedTime,
              securityNo: task?.securityNo,
              prn: task?.prn,
              workerName: task?.workerName,
              arrDep: task?.arrDep,
              PAXName: task?.PAXName,
              rejectReason: task?.rejectReason
            };
            rejectedCSVData.push(rejectedOBJ);
          });
        }
        handleExcel(`Rejected-Tasks`, rejectedTasksTitles, rejectedCSVData);
      }
      if (analyticsType == "totalAssignedTasks") {
        let assignedCSVData = [];
        let assignedCounter = 1;

        let tempAssignedTasks = allTasksWithFilterCSV?.filter(
          (row) => row?.serviceStatus !== "completed"
        );
        if (tempAssignedTasks?.length > 0) {
          tempAssignedTasks.forEach((task) => {
            let unCompletedOBJ = {
              index: `${assignedCounter++}`,
              requestType: task?.requestType,
              flightDate: task?.flightDate,
              flightNo: task?.flightNo,
              flightTime: task?.flightTime,
              origin: task?.origin,
              destination: task?.destination,
              seatNo: task?.seatNo,
              assignedTime: task?.assignedTime,
              prn: task?.prn,
              workerName: task?.workerName,
              arrDep: "A",
            };
            assignedCSVData.push(unCompletedOBJ);
          });
        }
        handleExcel(
          `Assigned-Tasks`,
          assignedTasksTitles,
          assignedCSVData
        );
      }


      dispatch(resetAllTasksWithFilter());
    }
  }, [allTaskWithFilterStatus, allTasksWithFilterCSV, analyticsType]);
  useEffect(() => {
    if (dbUser) {
      dispatch(getAirportBase64Logo(dbUser.details.authority))
    }
  }, [])

  // on render listener
  useEffect(() => {
    // reset on render
    dispatch(resetAllTasksWithFilter());
  }, []);
  //#endregion

  return (
    <Row className="p-3">
      <Col xs={12}>

        {/* <Col>
          <Title>{"Timeline Analytics"}</Title>
          <Subtitle>{"Show tasks analytics, Total, Complete, Rejected, Assigned"}</Subtitle>
        </Col> */}
        <Row className="mt-3">
          {/* total cards */}
          <Col xs={12} sm={6} md={3} lg={3}>
            <CustomCard
              title={"Total Tasks"}
              data={timeLineAnalytics?.totalTasks ?? 0}
              onClick={() => openFilterModal("totalTasks")}
              marginLeft={false}
            />
          </Col>
          <Col xs={12} sm={6} md={3} lg={3}>
            <CustomCard
              title={"Completed Tasks"}
              data={timeLineAnalytics?.completedTasks ?? 0}
              onClick={() => openFilterModal("totalTasksCompleted")}
              marginLeft={true}
            />
          </Col>
          <Col xs={12} sm={6} md={3} lg={3}>
            <CustomCard
              title={"Rejected Tasks"}
              data={timeLineAnalytics?.rejectedTasks ?? 0}
              onClick={() => openFilterModal("totalRejectedTasks")}
              marginLeft={true}
            />
          </Col>
          <Col xs={12} sm={6} md={3} lg={3}>
            <CustomCard
              title={"Assigned Tasks"}
              data={timeLineAnalytics?.assignedTasks ?? 0}
              onClick={() => openFilterModal("totalAssignedTasks")}
              marginLeft={true}
            />
          </Col>

        </Row>


        <Row className="mt-3">
          <Col xs={12}>
            <TimelineAnalyticsTable />
          </Col>

        </Row>

        {/* excel sheet filter modal */}
        <ActionsModal
          show={filterModal}
          handleClose={closeFilterModal}
          title="Filter report data"
          minWidth="445px"
          maxWidth="445px"
          isTimeline={true}
        >
          <TimelineAnalyticsFilter closeFilterModal={closeFilterModal} analyticsType={analyticsType} />
        </ActionsModal>
      </Col>
    </Row>
  );
};

export default TimelineAnalytics;

